import {NgModule} from '@angular/core';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {TechnicalDeviceDocumentApiService} from '@api/technical-device-document.api.service';
import {TechnicalDeviceElementsGroupApiService} from '@api/technical-device-elements-group.api.service';
import {EquipmentCardPagingApiService} from '@api/equipment-card-paging.api.service';
import {TechnicalDeviceElementApiService} from '@api/technical-device-element.api.service';
import {TechnicalDeviceTechnicalCardApiService} from '@api/technical-device-technical-card.api.service';
import {ConclusionApiService} from '@api/conclusion.api.service';
import {InspectionApiService} from '@api/inspection.api.service';
import {DefectApiService} from '@api/defect.api.service';
import {TechnicalDeviceElementTypeApiService} from '@api/technical-device-element-type.api.service';
import {SelectValuesApiService} from '@api/select-values.api.service';
import {LabsApiService} from '@api/labs.api.service';

/**
 * Модуль с API сервисами
 */
@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        WorkingObjectsApiService,
        TechnicalDeviceApiService,
        TechnicalDeviceDocumentApiService,
        EquipmentCardPagingApiService,
        TechnicalDeviceElementsGroupApiService,
        TechnicalDeviceElementApiService,
        TechnicalDeviceTechnicalCardApiService,
        ConclusionApiService,
        InspectionApiService,
        DefectApiService,
        TechnicalDeviceElementTypeApiService,
        SelectValuesApiService,
        LabsApiService,
    ],
})
export class ApiModule {
}
